var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1003.54 272.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.54,
    y1: 59.79,
    x2: 153.34,
    y2: 59.79,
    gradientTransform: "matrix(1, 0, 0, -1, 0.18, 275.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3d331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0c42e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 150.73,
    y1: 228.87,
    x2: 230.89,
    y2: 228.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 129.74,
    y1: 260.43,
    x2: 188.71,
    y2: 260.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 153.22,
    y1: 195.83,
    x2: 281.4,
    y2: 195.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 7.88,
    y1: 94.64,
    x2: 153.34,
    y2: 94.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 200.75,
    y1: 106.87,
    x2: 200.75,
    y2: 106.87,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86bd40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#248034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 150.73,
    y1: 68.5,
    x2: 273.47,
    y2: 68.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0.18, 275.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.18,
    y1: 212.14,
    x2: 140.68,
    y2: 212.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 406.35,
    y1: -35.73,
    x2: 747.41,
    y2: -35.73,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 406.35,
    y1: -40.73,
    x2: 747.48,
    y2: -40.73,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 406.35,
    y1: -50.99,
    x2: 747.48,
    y2: -50.99,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 406.35,
    y1: -52.24,
    x2: 747.48,
    y2: -52.24,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 748.24,
    y1: -38.19,
    x2: 1128.31,
    y2: -38.19,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 748.24,
    y1: -37.56,
    x2: 1128.31,
    y2: -37.56,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 748.24,
    y1: -53.43,
    x2: 1128.31,
    y2: -53.43,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 748.24,
    y1: -54.73,
    x2: 1128.31,
    y2: -54.73,
    gradientTransform: "matrix(1, 0, 0, -1, -124.95, 109.53)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.52 176.45 140.85 193.88 130.93 207.53 98.93 251.58 84.04 272.08 58.72 272.08 73.59 251.58 118.28 190.11 128.18 176.45 140.85 159.01 153.52 176.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.06 0 216.18 20.48 163.55 92.93 150.9 75.49 190.85 20.48 205.73 0 231.06 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "188.89 0 166.18 29.81 129.91 29.81 129.91 0 188.89 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.05 159.01 281.58 0 256.27 0 153.4 141.6 166.05 159.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "128.18 106.73 140.85 89.31 153.52 106.73 140.85 124.17 128.18 141.6 115.53 159.03 105.6 172.67 92.94 155.24 105.6 172.67 48.28 251.58 33.38 272.08 8.05 272.08 22.95 251.58 92.94 155.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.8,2.66",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "178.84 141.6 166.05 159.01 233.43 251.58 208.11 251.58 163.55 190.25 150.9 207.69 197.66 272.08 273.64 272.08 178.84 141.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "140.85 89.31 128.18 106.73 65.52 20.48 40.21 20.48 104.48 108.96 91.81 126.4 0 0 75.97 0 140.85 89.31"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XtraTime"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.59,209l-24.36-43.75L312.51,209H281.4l41.28-65.06-39-62.39H315.2l23.16,41.27,23.17-41.27h30.91l-38.82,61.1,41.47,66.19Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M449.76,146.8h23.17v26.87a46,46,0,0,1-2.22,14.3,33.7,33.7,0,0,1-6.91,12.11,33.26,33.26,0,0,1-11.92,8.34,43.5,43.5,0,0,1-17.17,3.08,45.22,45.22,0,0,1-17.64-3.08,33.76,33.76,0,0,1-12-8.24,31.71,31.71,0,0,1-6.82-12.11,50.14,50.14,0,0,1-2.08-14.6V89h24.56v25.55h52.22V132.2H420.77V171a24.51,24.51,0,0,0,3.31,13.9,12.43,12.43,0,0,0,11.06,4.9,12.74,12.74,0,0,0,11.15-4.8,22.39,22.39,0,0,0,3.57-13.6Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M483.16,209V114.56h23.4v11.32A30,30,0,0,1,513,118.4a27.45,27.45,0,0,1,6.92-4.14,26.87,26.87,0,0,1,7.18-1.82,69.14,69.14,0,0,1,7.48-.39h3.31V137.6A40.17,40.17,0,0,0,531,137q-22.83,0-22.83,22.87V209Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M599.29,209a37.11,37.11,0,0,1-1.52-8.44,30.65,30.65,0,0,1-11.72,8,44.6,44.6,0,0,1-16.91,3q-16.27,0-23.89-7.22a24.52,24.52,0,0,1-7.58-18.69A34,34,0,0,1,541,169.37a23.91,23.91,0,0,1,9-9.5,43.61,43.61,0,0,1,13.73-5.1q7.95-1.65,17.38-3a33.81,33.81,0,0,0,12.67-3.54,8.12,8.12,0,0,0,3.31-7.21,8,8,0,0,0-4.3-7.18,22.15,22.15,0,0,0-11.61-2.62,16.79,16.79,0,0,0-12.38,3.84,17.89,17.89,0,0,0-4.7,10.19H540.91a43.57,43.57,0,0,1,2.38-13.43,25.85,25.85,0,0,1,7.12-10.56,33,33,0,0,1,12.77-6.82,67,67,0,0,1,19.2-2.41,62.63,62.63,0,0,1,18.9,2.51,30.57,30.57,0,0,1,12.47,7.18,27.52,27.52,0,0,1,6.82,11.72,55.48,55.48,0,0,1,2.12,15.85v59.58Zm-1.72-46.33a13.76,13.76,0,0,1-5.66,3.14,95.88,95.88,0,0,1-10.59,2.52,35.41,35.41,0,0,0-14.76,5.36,11.48,11.48,0,0,0-4,9.4q0,10.56,12.12,10.56a24,24,0,0,0,8.9-1.62,22.5,22.5,0,0,0,7.11-4.41,21.91,21.91,0,0,0,4.8-6.61,17.65,17.65,0,0,0,1.82-8Z",
    transform: "translate(0.18 -2.66)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Time"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M661.68,211.5V106.22H623.29V84H726.94v22.27H688.35V211.43Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M734.42,105.72V82.56h25v23.16Zm0,105.91V117h25V211.5Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M881.47,211.5V154.28a22.72,22.72,0,0,0-4-14,12.7,12.7,0,0,0-10.76-5.36,14,14,0,0,0-11.41,5.72,22.54,22.54,0,0,0-4.5,14.4V211.5h-25V154.67a47.84,47.84,0,0,0-.76-9.4,12.63,12.63,0,0,0-2.61-5.75,9.37,9.37,0,0,0-4.7-3,23.47,23.47,0,0,0-6.92-.86q-15.16,0-15.16,18.4V211.5h-25V117h23.43v13.84A27.82,27.82,0,0,1,805.58,118a34.77,34.77,0,0,1,16.12-3.31,42.26,42.26,0,0,1,8.54.76,20.81,20.81,0,0,1,6.61,2.59,26.86,26.86,0,0,1,5.66,4.7,57,57,0,0,1,5.56,6.65A25.22,25.22,0,0,1,858.24,118a31,31,0,0,1,15.35-3.54,34.8,34.8,0,0,1,13,2.38,29.83,29.83,0,0,1,10.2,6.62,32.18,32.18,0,0,1,6.61,10.1,31.49,31.49,0,0,1,2.39,12.27v65.47Z",
    transform: "translate(0.18 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M938.29,170.79a26.73,26.73,0,0,0,6.23,17.08,19,19,0,0,0,14.89,6.35,20.85,20.85,0,0,0,10.82-2.78,12.61,12.61,0,0,0,6.06-7.77H1002a41.2,41.2,0,0,1-15.35,22.44A43.42,43.42,0,0,1,960.53,214q-47.19,0-47.19-51.43a60.07,60.07,0,0,1,3-19.86,42.75,42.75,0,0,1,8.94-15.15,38.46,38.46,0,0,1,14.3-9.7A52.39,52.39,0,0,1,959,114.53q21.88,0,33.1,14t11.25,42.23ZM977.61,155a25.5,25.5,0,0,0-1.78-9.1,18.68,18.68,0,0,0-4.31-6.62,16.94,16.94,0,0,0-6.15-3.84,20.65,20.65,0,0,0-7.09-1.26,17.73,17.73,0,0,0-13,5.46,23.35,23.35,0,0,0-6.22,15.26Z",
    transform: "translate(0.18 -2.66)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db896299c5b740c28b6cd5ed34c505ac.svg";
export { ForwardRef as ReactComponent };